import type { RouteRecordRaw, Router } from 'vue-router'

const BuyContractRoutes: RouteRecordRaw = {
  path: '/contract/estate/mortgage',
  name: 'MortgageEstateModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'MortgageEstateMainRoute',
      component: () => import('./views/MortgageView.vue'),
      meta: {
        title: 'mortgageEstate.mortgageContract',
      },
    },
    {
      path: 'create',
      name: 'MortgageEstateCreateRoute',
      component: () => import('./views/MortgageUpsertView.vue'),
      meta: {
        title: 'mortgageEstate.createViewTitle',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:mortgageEstateId',
      name: 'MortgageEstateEditRoute',
      component: () => import('./views/MortgageUpsertView.vue'),
      meta: {
        title: 'mortgageEstate.editViewTitle',
        pageHasBack: true,
      },
    },
    {
      path: 'renew/:mortgageEstateId',
      name: 'MortgageEstateRenewRoute',
      component: () => import('./views/MortgageUpsertView.vue'),
      meta: {
        title: 'renewContract',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:mortgageEstateId',
      name: 'ViewMortgageEstateRoute',
      component: () => import('./views/SingleMortgageView.vue'),
      meta: {
        title: 'mortgageEstate.singleViewTitle',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(BuyContractRoutes)
}
